import { Constants } from '@pwc/pwc-deals-web-common';
import { get, cloneDeep } from 'lodash';
import { getExcelLibraryItemsByGroup } from '../../../contentLibrary/libraryItemService';

class ChartLibraryItem {
  constructor(libraryItem, formatType = 'SVG') {
    this.data = JSON.parse(libraryItem.data);
    this.type = libraryItem.type;
    this.libraryItemType = Constants.LIBRARY_ITEM_TYPES.EXCEL_CHART.value;
    this.formatType = formatType;
    this.service = getExcelLibraryItemsByGroup;
    this.libraryItem = libraryItem;
  }

  extractSourceName() {
    return {
      source: `${this.data.worksheetName || this.data.WorksheetName} ${
        this.data.chartName || this.data.ChartName
      } `,
    };
  }

  getRequestPayload() {
    const data = {
      id: this.libraryItem.id,
      name: this.libraryItem.name,
      type: this.libraryItem.type,
      data: {
        formatType: this.formatType,
        chartName: get(this.data, 'ChartName'),
        workSheetName: get(this.data, 'WorksheetName'),
        uniqueId: get(this.data, 'UniqueId'),
      },
    };

    return {
      ...cloneDeep(this.data),
      excelLibraryItems: [data],
    };
  }
}

export default ChartLibraryItem;
